import { render, staticRenderFns } from "./BaseVideoPlayer.vue?vue&type=template&id=af31e000"
import script from "./BaseVideoPlayer.vue?vue&type=script&lang=js"
export * from "./BaseVideoPlayer.vue?vue&type=script&lang=js"
import style0 from "./BaseVideoPlayer.vue?vue&type=style&index=0&id=af31e000&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports